"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var date_1 = require("@utils/date/date");
var react_i18next_1 = require("react-i18next");
var JobField_1 = __importDefault(require("@features/ItemCommon/components/common/JobField"));
var itemDatesUtil_1 = require("./itemDatesUtil");
function ItemDates(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var job = _a.job, domain = _a.domain;
    var t = (0, react_i18next_1.useTranslation)().t;
    var createdAt = ((_e = (_d = (_c = (_b = job === null || job === void 0 ? void 0 : job.ad) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.statusOnSite) === null || _e === void 0 ? void 0 : _e.timestamp) && new Date(job.ad.current.meta.statusOnSite.timestamp);
    var publishedAtDate = ((_j = (_h = (_g = (_f = job === null || job === void 0 ? void 0 : job.ad) === null || _f === void 0 ? void 0 : _f.current) === null || _g === void 0 ? void 0 : _g.meta) === null || _h === void 0 ? void 0 : _h.statusOnSite) === null || _j === void 0 ? void 0 : _j.publishedAt) && new Date(job.ad.current.meta.statusOnSite.publishedAt);
    var updatedAtDate = ((_o = (_m = (_l = (_k = job === null || job === void 0 ? void 0 : job.ad) === null || _k === void 0 ? void 0 : _k.current) === null || _l === void 0 ? void 0 : _l.meta) === null || _m === void 0 ? void 0 : _m.statusOnSite) === null || _o === void 0 ? void 0 : _o.updatedAt) && new Date(job.ad.current.meta.statusOnSite.updatedAt);
    var getTooltipLabel = function (dateToTooltip) {
        if (dateToTooltip) {
            var _a = (0, date_1.formatDateWithGMT)(dateToTooltip), timestampFormatted = _a.timestampFormatted, formattedTimeZone = _a.formattedTimeZone;
            return t('ITEM.TIMESTAMP_TOOLTIP_REACT', {
                TIMESTAMP: timestampFormatted,
                TIMEZONE: formattedTimeZone,
            });
        }
        return undefined;
    };
    // Time is used to force a refresh of the component
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _p = __read((0, react_1.useState)(Date.now()), 2), time = _p[0], setTime = _p[1];
    var refreshInterval = (0, itemDatesUtil_1.getRefreshInterval)(createdAt, publishedAtDate, updatedAtDate);
    (0, react_1.useEffect)(function () {
        var interval = setInterval(function () { return setTime(Date.now()); }, refreshInterval);
        return function () {
            clearInterval(interval);
        };
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        createdAt && (react_1.default.createElement(JobField_1.default, { label: t('ITEM.CREATED_AT'), value: (0, date_1.getIntervalLabel)(createdAt, true), setValue: function () { }, isNotEditable: true, domain: domain, showCopyIcon: false, showQuickAddToList: false, tooltipText: getTooltipLabel(createdAt), automationListsPermission: {} })),
        publishedAtDate && (react_1.default.createElement(JobField_1.default, { label: t('ITEM.PUBLISHED_AT'), value: (0, date_1.getIntervalLabel)(publishedAtDate, true), setValue: function () { }, isNotEditable: true, domain: domain, showCopyIcon: false, showQuickAddToList: false, tooltipText: getTooltipLabel(publishedAtDate), automationListsPermission: {} })),
        updatedAtDate && (react_1.default.createElement(JobField_1.default, { label: t('ITEM.UPDATED_AT'), value: (0, date_1.getIntervalLabel)(updatedAtDate, true), setValue: function () { }, isNotEditable: true, domain: domain, showCopyIcon: false, showQuickAddToList: false, tooltipText: getTooltipLabel(updatedAtDate), automationListsPermission: {} }))));
}
exports.default = ItemDates;
